__turbopack_context__.v({
  "freeBox": "PlasmicLabel-module__POPeJa__freeBox",
  "root": "PlasmicLabel-module__POPeJa__root",
  "slotTargetChildrensize_lg": "PlasmicLabel-module__POPeJa__slotTargetChildrensize_lg",
  "slotTargetChildrensize_sm": "PlasmicLabel-module__POPeJa__slotTargetChildrensize_sm",
  "text": "PlasmicLabel-module__POPeJa__text",
  "textrequirementIndicator_optional": "PlasmicLabel-module__POPeJa__textrequirementIndicator_optional",
  "textrequirementIndicator_required": "PlasmicLabel-module__POPeJa__textrequirementIndicator_required",
});
